import { SwApiStore } from "@sourcewhale/shared/src/svelte/api-stores/sw-api-store";
import { getAllIntegrations } from "../api/integrations";

export const IntegrationsStore = (params) =>
  SwApiStore({ get: () => getAllIntegrations(params) });

export const integrationsStore = IntegrationsStore();
